import { Color } from "three";

export const THEME_COLORS = {
    primaryDark: new Color(0x44484b),
    primary: new Color(0x707478),
    secondaryDark: new Color(0x857a6d),
    secondary: new Color(0xc2bab0),
    secondaryLight: new Color(0xe5dfd7),
    generalBlack: new Color(0x1c1a19),
    generalWhite: new Color(0xffffff),
    generalBg: new Color(0xefefef),
    gray1: new Color(0x8b8987),
    gray2: new Color(0xa6a4a3),
    gray3: new Color(0xc3c3c3),
    gray4: new Color(0xf9f9f9),
    statusError: new Color(0xc20909),
    highlightedItemBlue: new Color(0x1164ff),
    highlightedItemPurple: new Color(0xe560ff),
    highlightedItemOrange: new Color(0xff6411),
};

export const ROOM_COLOR_SELECTOR_PALETTE = [
    new Color(0xe6e0d3), // https://www.market-krasok.ru/help/colors/olsta-architect-colours/olsta-079/
    new Color(0xf8f8f5), // https://www.market-krasok.ru/help/colors/olsta-architect-colours/olsta-001/
    new Color(0x5f5e5e), // https://www.market-krasok.ru/help/colors/ncs_second_edition/S-7500-N/
    new Color(0xffdba1), // https://www.market-krasok.ru/help/colors/benjamin_moore_color_preview/BM-2018-50/
    new Color(0xb9c376), // https://www.market-krasok.ru/help/colors/benjamin_moore_color_preview/BM-2029-40/
    new Color(0xb4dadb), // https://www.market-krasok.ru/help/colors/benjamin_moore_color_preview/BM-2052-60/
    new Color(0xefdad5), // https://www.market-krasok.ru/help/colors/benjamin_moore_color_preview/BM-2092-70/
];
